// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3TGOL","footer":"Form_footer__1V9I_"};